<div class="row text-center">
    <H5 paflabel="Demande_de_referencement_fournisseur"></H5>
</div>
<form #frmNewSupplier="ngForm" #aForm>
    <div class="card mb-2">
        <div class="card-header">
            <label class="control-label" paflabel="Coordonnees_du_fournisseur"></label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-2">
                    <paf-combobox name="civility" [data]="sharedDatasSvc.civilities" [(ngModel)]="civility"
                        headerPafLabel="Civilite"></paf-combobox>
                </div>
                <div class="col-6">
                    <label class="control-label" paflabel="Nom"></label>
                    <input name="lastname" class="form-control" type="text" [(ngModel)]="contact.Lastname" 
                        required>
                    <validation-errors [form]="frmNewSupplier" controlName="lastname"></validation-errors>
                </div>
                <div class="col-4">
                    <label class="control-label" paflabel="Prenom"></label>
                    <input name="firstname" class="form-control" type="text" [(ngModel)]="contact.Firstname" 
                        required>
                    <validation-errors [form]="frmNewSupplier" controlName="firstname"></validation-errors>

                </div>
            </div>
            <div class="row">
                <div class="col-2">
                    <label class="control-label" paflabel="Telephone"></label>
                    <input name="phone" class="form-control" type="text" [(ngModel)]="contact.Phone" required>
                    <validation-errors [form]="frmNewSupplier" controlName="phone"></validation-errors>
                </div>
                <div class="col-5">
                    <label class="control-label" paflabel="Email"></label>
                    <input name="email" class="form-control" type="email" [(ngModel)]="contact.Email" email="true"
                        emailUnique onBlurValidator required>
                    <validation-errors [form]="frmNewSupplier" controlName="email"></validation-errors>
                </div>
                <div class="col-5">
                    <label class="control-label" paflabel="Fonction"></label>
                    <input name="fonction" class="form-control" type="text" [(ngModel)]="contact.Fonction">
                </div>

            </div>
        </div>
    </div>

    <div class="card mb-2">
        <div class="card-header">
            <label class="control-label" paflabel="Informations_societes"></label>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-6 offset-5 text-info">
                    <i class="fas fa-info-circle"></i>
                    <label class="control-label ml-2" paflabel="Demande_referencement_Msg_ordre_saisie"></label>
                </div>
            </div>
            <div class="row">
                <div class="col-3 offset-1">
                    <div class="d-flex flex-column">
                        <paf-combobox name="country" [data]="sharedDatasSvc.countries" [(ngModel)]="country"
                            headerPafLabel="Pays" (selectedObjectChange)="onCountryChange($event)"
                            [required]="true"></paf-combobox>
                        <validation-errors [form]="frmNewSupplier" controlName="country"></validation-errors>
                        <paf-combobox name="country" [data]="countryLegalforms" [(ngModel)]="legalform"
                            headerPafLabel="Forme_juridique" [required]="true"></paf-combobox>
                        <validation-errors [form]="frmNewSupplier" controlName="legalform"></validation-errors>
                    </div>
                    <div *ngIf="uniqueIdToShow=='siret'">
                        <div class="row">
                            <div class="col">
                                <label class="control-label" paflabel="Num_Siret"></label>
                                <input name="siret" onlyNumbers siretValidator siretUnique siretActif siretSiege
                                    class="form-control" type="text" [(ngModel)]="supplier.Siret"
                                    [ngModelOptions]="{updateOn: 'blur'}" required (blur)="findSiret()"
                                    mask="00000000000000">
                            </div>
                            <div class="col mt-3" *ngIf="getShowBtnSupplierId(frmNewSupplier)">
                                <a class="btn btn-outline-primary" type="button"
                                    [routerLink]="supplierDetailLink(getShowBtnSupplierId(frmNewSupplier))"
                                    target="_blank">
                                    <span paflabel="Fiche_fournisseur"></span>&nbsp;<i class="fas fa-address-card"></i>
                                </a>
                            </div>
                        </div>
                        <validation-errors [form]="frmNewSupplier" controlName="siret"></validation-errors>
                    </div>
                    <div *ngIf="uniqueIdToShow=='tvaintra'">
                        <div class="row">
                            <div class="col">
                                <label class="control-label" paflabel="Num_Intratva"></label>
                                <input name="tvaIntra" class="form-control" type="text" [(ngModel)]="supplier.TvaIntra"
                                    [intraTvaValidator]="country" intraTvaUnique onBlurValidator required
                                    (blur)="findIntraTva()">
                                <validation-errors [form]="frmNewSupplier" controlName="tvaIntra"></validation-errors>
                            </div>
                            <div class="col mt-3"
                                *ngIf="frmNewSupplier.controls['tvaIntra'] && frmNewSupplier.controls['tvaIntra'].errors && frmNewSupplier.controls['tvaIntra'].errors.intraTvaUnique">
                                <button class="btn btn-outline-primary" type="button"
                                    [routerLink]="IntraTvaErrorSupplierDetailLink" browserTabLink>
                                    <span paflabel="Fiche_fournisseur"></span>&nbsp;<i class="fas fa-address-card"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="uniqueIdToShow=='duns'">
                        <label class="control-label" paflabel="Num_DUNS"></label>
                        <input name="duns" class="form-control" type="text" [(ngModel)]="supplier.Duns" required
                            dunsUnique>
                        <validation-errors [form]="frmNewSupplier" controlName="duns"></validation-errors>
                    </div>
                    <div *ngIf="uniqueIdToShow=='rsa'">
                        <label class="control-label" paflabel="Num_RSA"></label>
                        <input name="rsa" class="form-control" type="text" [(ngModel)]="supplier.Rsa" required
                            maxlength="14" rsaUnique>
                        <validation-errors [form]="frmNewSupplier" controlName="rsa"></validation-errors>
                    </div>
                </div>
                <div class="col-6 offset-1">
                    <div class="d-flex flex-column">
                        <div class="mb-1">
                            <label class="control-label" paflabel="Raison_sociale"></label>
                            <input name="suppliername" class="form-control" type="text" maxlength="80"
                                [(ngModel)]="supplier.SupplierName" required>
                            <validation-errors [form]="frmNewSupplier" controlName="suppliername"></validation-errors>
                        </div>
                        <div class="flex-grow-1">
                            <div class="card px-2 pb-1">
                                <div class="d-flex flex-column">
                                    <label class="control-label" paflabel="Adresse"></label>
                                    <div style="width:100%;" class="d-flex">
                                        <div style="width:60px;" class="mr-1">
                                            <input name="AddrNum" class="form-control" type="text"
                                                [(ngModel)]="address.AddrNum" style="width:100%;"
                                                pafplaceholder="Num_Rue" [disabled]="addrDisabled">
                                        </div>
                                        <div class="flex-grow-1">
                                            <input name="addr1" class="form-control" type="text"
                                                pafplaceholder="Adresse" [(ngModel)]="address.Addr1" style="width:100%;"
                                                [disabled]="addrDisabled">
                                        </div>
                                    </div>
                                    <input name="addr2" class="form-control my-1" type="text"
                                        [(ngModel)]="address.Addr2" pafplaceholder="Complement_d_adresse"
                                        style="width:100%;" [disabled]="addrDisabled">
                                    <div style="width:100%;" class="d-flex">
                                        <div style="width:150px;" class="mr-1">
                                            <input name="postalCod" class="form-control" type="text"
                                                pafplaceholder="Code_postal" [(ngModel)]="address.PostalCod"
                                                style="width:100%;" required [disabled]="addrDisabled" maxlength="9">
                                            <validation-errors [form]="frmNewSupplier" controlName="postalCod">
                                            </validation-errors>
                                        </div>
                                        <div class="flex-grow-1">
                                            <input name="city" class="form-control" type="text" pafplaceholder="Ville"
                                                [(ngModel)]="address.City" required style="width:100%;"
                                                [disabled]="addrDisabled">
                                            <validation-errors [form]="frmNewSupplier" controlName="city">
                                            </validation-errors>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-3 offset-1 d-flex">
                    <label class="control-label mt-3 text-right" paflabel="Langue_utilisee_avec_le_fournisseur"></label>
                    <div class="d-flex flex-column align-items-center mr-2">
                        <img class="lng-btn mb-1" [src]="frBtnImagePath">
                        <input id="optFR" type="radio" value="FR" name="LngCod" [(ngModel)]="supplier.LngCod">
                    </div>
                    <div class="d-flex flex-column align-items-center">
                        <img class="lng-btn mb-1" [src]="enBtnImagePath">
                        <input id="optEN" type="radio" value="EN" name="LngCod" [(ngModel)]="supplier.LngCod">
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="card">
        <div class="card-header">
            <label class="control-label" paflabel="Raison_de_l_ouverture"></label>
        </div>
        <div class="card-body">
            <textarea rows="3" name="DemandReason" class="form-control" maxlength="1024"
                [(ngModel)]="supplier.DemandReason" style="width: 100%; height: 40px;"></textarea>
        </div>
    </div>

    <BR>
    <div class="row  justify-content-center">
        <div class="col-2  align-self-center">
            <button btnDebounceClick class="btn btn-primary" type="button" (debounceClick)="submitSupplier()"
                [debounceTime]="700" paflabel="Envoyer_au_fournisseur"></button>
        </div>
        <div class="col-2  align-self-center">
            <button btnDebounceClick class="btn btn-primary" type="button" (debounceClick)="continuerSaisie()"
                [debounceTime]="700" paflabel="Completer_le_dossier"></button>
        </div>
    </div>



</form>

<PRE *ngIf="sharedDatasSvc.debug">
    Forme juridiquee : {{legalform| json }}
    <BR>
    Fournisseur : {{supplier | json }}

</PRE>